import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { RouteComponentProps } from 'react-router';

import { translations } from '@/locale';

import Typography from '@/components/Typography';
import TabbedContainer from '@/components/TabbedContainer';
import Tab from '@/components/TabbedContainer/Tab';
import { urls } from '@/constants';
import OrganizationMembersTab from './Tabs/OrganizationMembersTab';
import OrganizationGeneralTab from './Tabs/OrganizationGeneralTab';
import OrganizationDiningSlotsTab from './Tabs/OrganizationDiningSlotsTab';
import OrganizationAccessTab from './Tabs/OrganizationAccessTab';

const text = translations.pages.organizations;

const OrganizationDetailPage: React.FC<RouteComponentProps<{ id: string }> & WrappedComponentProps> = ({
  intl,
  match
}) => {
  const orgId = match.params.id;
  return (
    <div className="space-y-4">
      <div className="flex">
        <Typography is="h1" size="2xl" weight="bold">
          Organization profile
        </Typography>
      </div>

      <TabbedContainer resourceId={orgId}>
        <Tab title={intl.formatMessage({ id: text.tabs.general.title })} to={urls.organizations.detail}>
          <OrganizationGeneralTab id={orgId} />
        </Tab>

        <Tab title={intl.formatMessage({ id: text.tabs.diningSlots.title })} to={urls.organizations.diningSlots}>
          <OrganizationDiningSlotsTab id={orgId} />
        </Tab>

        <Tab title={intl.formatMessage({ id: text.tabs.members.title })} to={urls.organizations.members}>
          <OrganizationMembersTab id={orgId} />
        </Tab>

        <Tab title={intl.formatMessage({ id: text.tabs.access.title })} to={urls.organizations.access}>
          <OrganizationAccessTab id={orgId} />
        </Tab>
      </TabbedContainer>
    </div>
  );
};

export default injectIntl(OrganizationDetailPage);
